<template>
    <v-container>
        <v-layout row wrap pb-4 align-center>
            <v-flex xs12 md6>
                <h1>Parliamentary office holders</h1>
            </v-flex>
        </v-layout>

        <v-layout row wrap align-center justify-space-between>
            <v-btn-toggle v-model="viewType" class="transparent handbook_toggleButton" :mandatory="true">
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'timeline'"><span class="long-button-text chamberButton">Timeline</span></v-btn>
                    </template>
                    <span>Timeline</span>
                </v-tooltip>
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'table'"><span class="long-button-text chamberButton">Table</span></v-btn>
                    </template>
                    <span>Table</span>
                </v-tooltip>
            </v-btn-toggle>
        </v-layout>

        <br/>

        <statutory-office-holder-timeline v-show="viewType === 'timeline'" />

        <div v-show="viewType === 'table'">
            <parliamentary-office-holders header="Clerks of the Senate" :positionType="1"></parliamentary-office-holders>
            <br/>
            <parliamentary-office-holders header="Clerks of the House of Representatives" :positionType="2"></parliamentary-office-holders>
            <br/>
            <parliamentary-office-holders header="Principal Parliamentary Reporters" :positionType="7"></parliamentary-office-holders>
            <br/>
            <parliamentary-office-holders header="Joint House Department Secretaries" :positionType="8"></parliamentary-office-holders>
            <br/>       
            <parliamentary-office-holders header="Department of Parliamentary Services Secretaries" :positionType="3"></parliamentary-office-holders>
            <br/>         
            <parliamentary-office-holders header="Parliamentary Librarians" :positionType="4"></parliamentary-office-holders>
            <br/>
            <parliamentary-office-holders header="Parliamentary Budget Officers" :positionType="5"></parliamentary-office-holders>
        </div>
        <br/>
    </v-container>
</template>
<script>

import StatutoryOfficeHolderTimeline from '../StatisticalInformation/StatutoryOfficeHolderTimeline.vue'
import ParliamentaryOfficeHolders from './ParliamentaryOfficeHolders.vue'

export default {
    data() {
        return {
            title: 'Parliamentary Statutory Office Holders',
            viewType: 'timeline'
        }
    },
    components: {
        ParliamentaryOfficeHolders,
        StatutoryOfficeHolderTimeline
    }
}
</script>
<style scoped>
    .v-datatable {
        margin-bottom: 1rem;
    }
    h2 {
        margin-bottom: 1rem;
    }
</style>